export default __webpack_public_path__ + "static/media/kitchen3-before3-1024w.83c9a28a.avif";